import { TranslatePipe } from '../../filters/translate.pipe';
import { ElementRef } from '@angular/core';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Popper from 'popper.js';
import AngularHelperService from '../../services/angular-helper.service';
import { Input } from '@angular/core';
import AngularFilterHelperService from "../../services/angular-filter-helper.service";
import Session from '../../utils/session.service';

@Component({
    standalone: true,
    selector: 'synchronize-calendar-info-popover',
    templateUrl: './synchronize-calendar-info-popover.component.html',
    imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class SynchronizeCalendarInfoPopoverComponent implements OnInit, OnDestroy {
    private angularHelperService: AngularHelperService = inject(AngularHelperService);

    private readonly angularFilterHelperService = inject(AngularFilterHelperService);
    private readonly session = inject(Session);

    @Input() color: any | undefined;
    @Input() wrapper: any | undefined;
    @Input() placement: any | undefined;
    @Input() placementMobile: any | undefined;
    @Input() wrapperMobile: any | undefined;

    vm: any = undefined;
    watcher: any = undefined;

    constructor(private elementRef: ElementRef) {
        this.vm = this;
    }

    ngOnInit() {
        this.vm.user = this.session.getSession().user;
        this.vm.origin = this.vm.user.origin;
        if(this.vm.origin === 'minudoc.ee')  {
            this.vm.originTitle = 'Minudoc';
        } else {
            this.vm.originTitle = 'Siffi';
        }

        this.vm.mobileBreakpoint = 768;
        this.vm.placement = this.vm.placement || 'bottom';
        this.vm.placementMobile = this.vm.placementMobile || this.vm.placement;
        this.handleParamsUpdate();

        this.vm.element = this.angularHelperService.element(this.elementRef.nativeElement);
        this.vm.refElement = this.vm.element[0].querySelector('[data-ref]');
        this.vm.isOpen = false;

        this.angularHelperService.element(this.angularHelperService.getWindow()).on('resize', () => { this.handleParamsUpdate(); });

        var currentIsOpen = this.vm.isOpen;
        this.watcher = this.angularHelperService.createInterval(() => {
            var newIsOpen = this.vm.isOpen;
            if (currentIsOpen !== newIsOpen) {
                currentIsOpen = newIsOpen;
                this.handleIsOpenChange(newIsOpen);
            }
        }, 100);

        this.vm.handleRefButtonClick = this.handleRefButtonClick;
        this.vm.handleCloseButtonClick = this.handleCloseButtonClick;
        this.vm.redirect = this.redirect;
        this.vm.getSyncInfoDetailed = this.getSyncInfoDetailed;
    }

    ngOnDestroy() {
        this.angularHelperService.element(this.angularHelperService.getWindow()).off('resize', () => { this.handleParamsUpdate(); });
        if (this.watcher) {
            this.angularHelperService.cancelInterval(this.watcher);
        }
    }

    handleRefButtonClick() {
        this.vm.isOpen = !this.vm.isOpen;
    }

    handleCloseButtonClick() {
        this.vm.isOpen = false;
    }

    redirect($event, link) {
        $event.preventDefault();
        window.location.href = link;
    }

    handleIsOpenChange(isOpen) {
        if (isOpen) {
            requestAnimationFrame(() => {
                var modifiers: any = { flip: { behavior: [this.vm.placement, this.vm.placementMobile] } };
                if (this.vm.popperWrapper) modifiers.preventOverflow = { boundariesElement: this.vm.popperWrapper };

                this.vm.popoverElement = this.vm.element[0].querySelector('.c-popover');
                this.vm.popper = new Popper(this.vm.refElement, this.vm.popoverElement, {
                    placement: this.vm.popperPlacement,
                    removeOnDestroy: true,
                    modifiers: modifiers,
                });

                requestAnimationFrame(() => { this.vm.popper.update(); });
            });
        }
    }

    handleParamsUpdate() {
        if (window.innerWidth < this.vm.mobileBreakpoint) {
            this.vm.isMobile = true;
            this.vm.popperPlacement = this.vm.placementMobile;
            this.vm.popperWrapper = this.vm.wrapperMobile;
        } else {
            this.vm.isMobile = false;
            this.vm.popperPlacement = this.vm.placement;
            this.vm.popperWrapper = this.vm.wrapper;
        }
    }

    getSyncInfoDetailed() {
        return this.angularFilterHelperService.translate('Calendar.Sync_Info.Sync_Events_Info_Detailed')
            .replace('%s', "\"" + this.vm.originTitle + "\"")
    }
}